(function () {
  'use strict';

  var routes = (window.TBS && window.TBS.routes) || {};

  // Matches Liquid's `money` output (e.g. "Rs.1,399.00") so prices don't
  // change format after the cart drawer re-renders.
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var format = (window.TBS && window.TBS.moneyFormat) || 'Rs.{{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (match) {
      var value = amount;
      if (match[1] === 'amount_no_decimals') value = amount.replace(/\.\d+$/, '');
      return format.replace(match[0], value);
    }
    return 'Rs.' + amount;
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function qs(selector, ctx) { return (ctx || document).querySelector(selector); }
  function qsa(selector, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(selector)); }

  // Shows a small, auto-dismissing error message right after `anchorEl` —
  // a <tr> anchor gets a matching <tr><td colspan> so table markup stays valid.
  function showInlineError(anchorEl, message) {
    if (!anchorEl) return;
    var next = anchorEl.nextElementSibling;
    if (next && next.hasAttribute && next.hasAttribute('data-inline-error')) next.remove();
    var isRow = anchorEl.tagName === 'TR';
    var el = document.createElement(isRow ? 'tr' : 'p');
    el.setAttribute('data-inline-error', '');
    el.setAttribute('role', 'alert');
    el.className = 'inline-error';
    if (isRow) {
      el.innerHTML = '<td colspan="' + anchorEl.children.length + '" class="inline-error__cell"></td>';
      el.firstChild.textContent = message;
    } else {
      el.textContent = message;
    }
    anchorEl.insertAdjacentElement('afterend', el);
    setTimeout(function () { el.remove(); }, 5000);
  }

  function initMenuDrawer() {
    var toggle = qs('.site-header__menu-toggle');
    var drawer = qs('[data-menu-drawer]');
    if (!toggle || !drawer) return;

    function open() {
      drawer.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    toggle.addEventListener('click', open);
    qsa('[data-menu-drawer-close]', drawer).forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  var cartDrawer = null;

  function initCartDrawer() {
    cartDrawer = qs('[data-cart-drawer]');
    var toggles = qsa('[data-cart-toggle]');
    if (!cartDrawer) return;

    function open() {
      cartDrawer.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function close() {
      cartDrawer.hidden = true;
      document.body.style.overflow = '';
    }
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });
    // Delegated so close links inside re-rendered markup keep working.
    cartDrawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-drawer-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    cartDrawer.addEventListener('click', function (e) {
      var line = e.target.closest('[data-cart-item]');
      if (!line) return;
      var lineIndex = parseInt(line.getAttribute('data-line'), 10);

      if (e.target.closest('[data-cart-remove]')) {
        e.preventDefault();
        updateCartLine(lineIndex, 0, function (err) { if (err) showInlineError(line, err); });
      } else if (e.target.closest('[data-cart-qty-increase]')) {
        var qtyEl = qs('[data-cart-qty]', line);
        var newQty = parseInt(qtyEl.textContent, 10) + 1;
        updateCartLine(lineIndex, newQty, function (err) { if (err) showInlineError(line, err); });
      } else if (e.target.closest('[data-cart-qty-decrease]')) {
        var qtyEl2 = qs('[data-cart-qty]', line);
        var newQty2 = Math.max(0, parseInt(qtyEl2.textContent, 10) - 1);
        updateCartLine(lineIndex, newQty2, function (err) { if (err) showInlineError(line, err); });
      }
    });

    window.openCartDrawer = open;
  }

  function updateCartLine(line, quantity, onDone) {
    fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || !data || !data.items) {
            throw new Error((data && (data.description || data.message)) || 'That change couldn\'t be made — please try again.');
          }
          return data;
        });
      })
      .then(function (cart) {
        renderCart(cart);
        if (onDone) onDone(null, cart);
      })
      .catch(function (err) {
        if (onDone) onDone(err instanceof Error ? err.message : 'Something went wrong — please try again.');
      });
  }

  function renderCart(cart) {
    updateCartCount(cart.item_count);
    var body = qs('[data-cart-drawer-body]');
    if (!body) return;

    var heading = qs('.cart-drawer__header h2');
    if (heading) heading.textContent = 'Your Bag' + (cart.item_count > 0 ? ' (' + cart.item_count + ')' : '');

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="cart-drawer__empty"><p>Your bag is feeling a little too self-caring &mdash; empty!</p>' +
        '<a href="' + (routes.cartUrl ? routes.cartUrl.replace('/cart', '/collections/all') : '/collections/all') + '" class="btn btn--primary" data-cart-drawer-close>Start Shopping</a></div>';
      var footer = qs('.cart-drawer__footer');
      if (footer) footer.remove();
      return;
    }

    var itemsHtml = '<ul class="cart-drawer__items">';
    cart.items.forEach(function (item, index) {
      var original = item.original_line_price || (item.original_price * item.quantity);
      itemsHtml +=
        '<li class="cart-drawer__item" data-cart-item data-line="' + (index + 1) + '">' +
        '<a href="' + item.url + '" class="cart-drawer__item-image">' +
        (item.image ? '<img src="' + item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_200x200$1$2') + '" alt="" width="64" height="64">' : '') +
        '</a>' +
        '<div class="cart-drawer__item-details">' +
        '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
        (item.variant_title ? '<p class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
        '<div class="cart-drawer__item-actions">' +
        '<div class="cart-drawer__item-qty">' +
        '<button type="button" class="qty-btn" data-cart-qty-decrease aria-label="Decrease quantity">&minus;</button>' +
        '<span data-cart-qty>' + item.quantity + '</span>' +
        '<button type="button" class="qty-btn" data-cart-qty-increase aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<button type="button" class="cart-drawer__item-remove" data-cart-remove>Remove</button>' +
        '</div></div>' +
        '<div class="cart-drawer__item-price">' +
        (original > item.final_line_price ? '<s>' + formatMoney(original) + '</s>' : '') +
        '<span>' + formatMoney(item.final_line_price) + '</span></div>' +
        '</li>';
    });
    itemsHtml += '</ul>';

    body.innerHTML = itemsHtml;

    var savings = cart.total_discount || 0;
    var footerEl = qs('.cart-drawer__footer');
    if (!footerEl && cartDrawer) {
      var footerHtml =
        '<div class="cart-drawer__footer">' +
        '<div class="cart-drawer__row cart-drawer__row--saving" data-cart-savings-row hidden><span>Bundle savings</span><span data-cart-savings></span></div>' +
        '<div class="cart-drawer__row"><span>Delivery</span><span>Free</span></div>' +
        '<div class="cart-drawer__subtotal"><span>Total</span><span data-cart-subtotal></span></div>' +
        '<p class="cart-drawer__note">Cash on Delivery available</p>' +
        '<a href="' + routes.cartUrl + '/checkout" class="btn btn--primary btn--full">Checkout</a>' +
        '<a href="' + routes.cartUrl + '" class="cart-drawer__view-bag">View bag</a>' +
        '</div>';
      qs('.cart-drawer__panel').insertAdjacentHTML('beforeend', footerHtml);
    }

    var subtotalEl = qs('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    var savingsRow = qs('[data-cart-savings-row]');
    var savingsEl = qs('[data-cart-savings]');
    if (savingsRow && savingsEl) {
      savingsRow.hidden = savings <= 0;
      savingsEl.textContent = '−' + formatMoney(savings);
    }
  }

  function updateCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function addToCart(variantId, quantity, onDone) {
    fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            throw new Error((data && (data.description || data.message)) || 'That item couldn\'t be added to your bag.');
          }
          return fetch(routes.cartJson).then(function (r) { return r.json(); });
        });
      })
      .then(function (cart) {
        renderCart(cart);
        if (onDone) onDone(null, cart);
        if (window.openCartDrawer) window.openCartDrawer();
      })
      .catch(function (err) {
        if (onDone) onDone(err instanceof Error ? err.message : 'Something went wrong — please try again.');
      });
  }

  // Lets other components (e.g. the bundle builder) refresh and open the drawer.
  window.TBSRefreshCart = function (openDrawer) {
    return fetch(routes.cartJson || '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (openDrawer && window.openCartDrawer) window.openCartDrawer();
        return cart;
      });
  };

  function initProductForm() {
    var form = qs('[data-product-form] form');
    if (!form) return;

    var submitBtn = qs('[data-add-to-cart]', form);
    var buyNowBtn = qs('[data-buy-now]');
    var qtyInput = qs('[data-qty-input]', form);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantId = qs('[data-variant-id-input]', form).value;
      var quantity = parseInt(qtyInput.value, 10) || 1;
      submitBtn.disabled = true;
      var label = qs('[data-add-to-cart-text]', submitBtn);
      var originalText = label ? label.textContent : '';
      if (label) label.textContent = 'Adding...';
      addToCart(variantId, quantity, function (err) {
        submitBtn.disabled = false;
        if (label) label.textContent = err ? originalText : 'Added ✓';
        if (label && !err) setTimeout(function () { label.textContent = originalText; }, 1800);
        if (err) showInlineError(submitBtn, err);
      });
    });

    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        var variantId = qs('[data-variant-id-input]', form).value;
        var quantity = parseInt(qtyInput.value, 10) || 1;
        buyNowBtn.disabled = true;
        fetch(routes.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: quantity })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) {
                throw new Error((data && (data.description || data.message)) || 'That item couldn\'t be added to your bag.');
              }
              return data;
            });
          })
          .then(function () {
            window.location.href = (routes.cartUrl || '/cart') + '/checkout';
          })
          .catch(function (err) {
            buyNowBtn.disabled = false;
            showInlineError(buyNowBtn, err instanceof Error ? err.message : 'Something went wrong — please try again.');
          });
      });
    }
  }

  function initQuickAdd() {
    qsa('product-form-quick').forEach(function (el) {
      var btn = qs('[data-quick-add]', el);
      if (!btn) return;

      var variantsJson = qs('[data-quick-add-variants]', el);
      if (variantsJson) {
        // More than one variant (e.g. bundle scent combinations) — quick-add
        // can't safely guess which one the customer wants, so open a picker
        // instead of adding the default variant straight from the grid.
        btn.addEventListener('click', function () {
          try {
            openQuickAddPicker(JSON.parse(variantsJson.textContent));
          } catch (e) {
            showInlineError(btn, 'Something went wrong — please open the product page instead.');
          }
        });
        return;
      }

      btn.addEventListener('click', function () {
        var variantId = el.getAttribute('data-variant-id');
        var originalText = btn.textContent;
        btn.textContent = 'Adding...';
        btn.disabled = true;
        addToCart(variantId, 1, function (err) {
          btn.disabled = false;
          btn.textContent = err ? originalText : 'Added ✓';
          if (!err) setTimeout(function () { btn.textContent = originalText; }, 1800);
          if (err) showInlineError(btn, err);
        });
      });
    });
  }

  var quickAddPicker = null;

  function initQuickAddPicker() {
    quickAddPicker = qs('[data-quick-add-picker]');
    if (!quickAddPicker) return;

    function close() {
      quickAddPicker.hidden = true;
      document.body.style.overflow = '';
    }
    qsa('[data-quick-add-picker-close]', quickAddPicker).forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !quickAddPicker.hidden) close();
    });

    window.closeQuickAddPicker = close;
  }

  // Renders a small option-picker for `data` (the JSON embedded by
  // product-card.liquid: { title, options: [{name, position, values}],
  // variants: [{id, options, price, available}] }) into the shared
  // #QuickAddPicker dialog, and adds the matched variant on submit.
  function openQuickAddPicker(data) {
    if (!quickAddPicker) return;
    var body = qs('[data-quick-add-picker-body]', quickAddPicker);
    if (!body) return;

    var optionsHtml = data.options.map(function (option) {
      var valuesHtml = option.values.map(function (value, i) {
        return '<label class="option-pill"><input type="radio" name="qa-option-' + option.position + '" value="' +
          escapeHtml(value) + '"' + (i === 0 ? ' checked' : '') + ' data-qa-option-input><span>' +
          escapeHtml(value) + '</span></label>';
      }).join('');
      return '<fieldset class="product-form__option" data-qa-option-position="' + option.position + '">' +
        '<legend>' + escapeHtml(option.name) + '</legend>' +
        '<div class="product-form__option-values">' + valuesHtml + '</div></fieldset>';
    }).join('');

    body.innerHTML =
      '<h3 class="quick-add-picker__title">' + escapeHtml(data.title) + '</h3>' +
      '<div class="quick-add-picker__price" data-qa-price></div>' +
      optionsHtml +
      '<button type="button" class="btn btn--primary btn--full" data-qa-add>Add to Cart</button>';

    var priceEl = qs('[data-qa-price]', body);
    var addBtn = qs('[data-qa-add]', body);

    function getSelectedOptions() {
      return data.options
        .slice()
        .sort(function (a, b) { return a.position - b.position; })
        .map(function (option) {
          var checked = qs('input[name="qa-option-' + option.position + '"]:checked', body);
          return checked ? checked.value : null;
        });
    }

    function findVariant(options) {
      return data.variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === options[i]; });
      })[0];
    }

    function updateForSelection() {
      var variant = findVariant(getSelectedOptions());
      if (!variant) return;
      priceEl.textContent = formatMoney(variant.price);
      addBtn.disabled = !variant.available;
      addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      addBtn.setAttribute('data-variant-id', variant.id);
    }

    body.addEventListener('change', function (e) {
      if (e.target.hasAttribute('data-qa-option-input')) updateForSelection();
    });

    addBtn.addEventListener('click', function () {
      var variantId = addBtn.getAttribute('data-variant-id');
      var originalText = addBtn.textContent;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';
      addToCart(variantId, 1, function (err) {
        addBtn.disabled = false;
        addBtn.textContent = originalText;
        if (err) { showInlineError(addBtn, err); return; }
        if (window.closeQuickAddPicker) window.closeQuickAddPicker();
      });
    });

    updateForSelection();

    quickAddPicker.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function initQuantitySteppers() {
    document.addEventListener('click', function (e) {
      var incBtn = e.target.closest('[data-qty-increase]');
      var decBtn = e.target.closest('[data-qty-decrease]');
      if (!incBtn && !decBtn) return;
      var wrap = (incBtn || decBtn).closest('.quantity-selector');
      var input = qs('input[type="number"]', wrap);
      if (!input) return;
      var value = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || 0;
      value = incBtn ? value + 1 : Math.max(min, value - 1);
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function initCartPage() {
    var rows = qsa('[data-cart-item]', qs('.main-cart') || undefined);
    if (!rows.length || !qs('.main-cart')) return;

    rows.forEach(function (row) {
      var input = qs('[data-cart-qty-input]', row);
      if (!input) return;
      input.addEventListener('change', function () {
        var line = parseInt(row.getAttribute('data-line'), 10);
        var quantity = Math.max(0, parseInt(input.value, 10) || 0);
        fetch(routes.cartChange, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok || !data || !data.items) {
                throw new Error((data && (data.description || data.message)) || 'That change couldn\'t be made — please try again.');
              }
              return data;
            });
          })
          .then(function () { window.location.reload(); })
          .catch(function (err) {
            showInlineError(row, err instanceof Error ? err.message : 'Something went wrong — please try again.');
          });
      });
      row.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-remove]')) {
          e.preventDefault();
          input.value = 0;
          input.dispatchEvent(new Event('change'));
        } else if (e.target.closest('[data-cart-qty-increase]')) {
          input.value = (parseInt(input.value, 10) || 0) + 1;
          input.dispatchEvent(new Event('change'));
        } else if (e.target.closest('[data-cart-qty-decrease]')) {
          input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
          input.dispatchEvent(new Event('change'));
        }
      });
    });
  }

  function initVariantPicker() {
    var jsonEl = qs('[data-product-json]');
    var form = qs('[data-product-form] form');
    if (!jsonEl || !form) return;

    var product = JSON.parse(jsonEl.textContent);
    var variantIdInput = qs('[data-variant-id-input]', form);
    var priceEl = qs('[data-current-price]');
    var compareEl = qs('[data-compare-price]');
    var addBtn = qs('[data-add-to-cart]');
    var buyBtn = qs('[data-buy-now]');
    var addText = qs('[data-add-to-cart-text]');

    function getSelectedOptions() {
      var selected = [];
      qsa('fieldset[data-option-position]', form)
        .sort(function (a, b) { return a.getAttribute('data-option-position') - b.getAttribute('data-option-position'); })
        .forEach(function (fieldset) {
          var checked = qs('input[data-option-input]:checked', fieldset);
          selected.push(checked ? checked.value : null);
        });
      return selected;
    }

    function findVariant(options) {
      return product.variants.filter(function (v) {
        return v.options.every(function (opt, i) { return opt === options[i]; });
      })[0];
    }

    function updateUI(variant) {
      if (!variant) return;
      variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      var available = variant.available;
      [addBtn, buyBtn].forEach(function (btn) { if (btn) btn.disabled = !available; });
      if (addText) addText.textContent = available ? 'Add to Cart' : 'Sold Out';

      if (variant.featured_image) {
        var mainImg = qs('#ProductMainImage');
        if (mainImg) mainImg.src = variant.featured_image.src.replace(/(\.[a-zA-Z]+)(\?|$)/, '_1200x1200$1$2');
      }

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    form.addEventListener('change', function (e) {
      if (!e.target.hasAttribute('data-option-input')) return;
      var variant = findVariant(getSelectedOptions());
      updateUI(variant);
    });

    qsa('[data-product-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        qsa('[data-product-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        var mainImg = qs('#ProductMainImage');
        if (mainImg) mainImg.src = thumb.getAttribute('data-image-url');
      });
    });
  }

  // Hero banner carousel. The track is a real horizontally-scrolling,
  // scroll-snap element — touch swipe and trackpad scroll work natively,
  // with no hand-rolled gesture code. This just drives the autoplay
  // timer and keeps the dots/arrows/focus state in sync with whatever
  // slide the track is actually showing (including after a manual swipe).
  function initHeroCarousel() {
    var carousel = qs('[data-hero-carousel]');
    if (!carousel) return;
    var track = qs('[data-hero-track]', carousel);
    var slides = qsa('[data-hero-slide]', track);
    if (!track || slides.length < 2) return;

    var dots = qsa('[data-hero-dot]', carousel);
    var prevBtn = qs('[data-hero-prev]', carousel);
    var nextBtn = qs('[data-hero-next]', carousel);
    var autoplayEnabled = carousel.getAttribute('data-autoplay') === 'true';
    var autoplayMs = parseInt(carousel.getAttribute('data-autoplay-ms'), 10) || 3000;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var currentIndex = 0;
    var timer = null;

    function setActive(index) {
      currentIndex = index;
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      slides.forEach(function (slide, i) {
        var cta = qs('[data-hero-cta]', slide);
        if (cta) cta.tabIndex = i === index ? 0 : -1;
      });
    }

    function goTo(index, behavior) {
      var clamped = (index + slides.length) % slides.length;
      track.scrollTo({ left: track.clientWidth * clamped, behavior: behavior || 'smooth' });
      setActive(clamped);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function start() {
      if (!autoplayEnabled || reducedMotion) return;
      stop();
      timer = setInterval(function () { goTo(currentIndex + 1); }, autoplayMs);
    }

    // If the visitor swipes/scrolls the track manually, follow along
    // instead of fighting it or letting the dots drift out of sync.
    var scrollSyncTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollSyncTimeout);
      scrollSyncTimeout = setTimeout(function () {
        var index = Math.round(track.scrollLeft / track.clientWidth);
        if (index !== currentIndex) setActive(index);
      }, 100);
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); start(); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); start(); });

    carousel.addEventListener('pointerenter', stop);
    carousel.addEventListener('pointerleave', start);
    carousel.addEventListener('touchstart', stop, { passive: true });
    carousel.addEventListener('touchend', start, { passive: true });
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', function (e) {
      if (!carousel.contains(e.relatedTarget)) start();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    setActive(0);
    start();
  }

  function initCarousels() {
    qsa('[data-carousel]').forEach(function (carousel) {
      var track = qs('[data-carousel-track]', carousel);
      var prev = qs('[data-carousel-prev]', carousel);
      var next = qs('[data-carousel-next]', carousel);
      if (!track) return;
      function scrollAmount() { return track.clientWidth * 0.8; }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
    });
  }

  function initCollectionFilters() {
    qsa('[data-filter-checkbox]').forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        var url = checkbox.checked
          ? checkbox.getAttribute('data-filter-url')
          : checkbox.getAttribute('data-filter-url-remove');
        if (url) window.location.href = url;
      });
    });
    var sortSelect = qs('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }
    qsa('[data-price-filter-form]').forEach(function (formEl) {
      formEl.addEventListener('submit', function (e) {
        e.preventDefault();
        var url = new URL(window.location.href);
        qsa('input', formEl).forEach(function (input) {
          if (input.value) url.searchParams.set(input.name, input.value);
          else url.searchParams.delete(input.name);
        });
        window.location.href = url.toString();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenuDrawer();
    initCartDrawer();
    initProductForm();
    initQuickAddPicker();
    initQuickAdd();
    initQuantitySteppers();
    initCartPage();
    initVariantPicker();
    initHeroCarousel();
    initCarousels();
    initCollectionFilters();
  });
})();
